module.exports = __webpack_public_path__ + "static/fixit_felix-45e17dec868c4a1d9f1c9b0283c60cdd.jpg";